<template>
  <IMenu v-model="isShow" width="292" @hide="onHideMenu">
    <template #menu>
      お気に入りイベントに追加しませんか？<br />
      開催のお知らせをメールでお届けします。
    </template>
  </IMenu>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { getFromStorage, setToStorage } from '@/js/lib/helper/expirable-local-storage';
import { sleep } from '@/js/lib/helper/sleep';
import IMenu from '@/js/components/molecules/IMenu.vue';

const props = defineProps<{
  liked?: boolean;
}>();
const KEY = 'close-event-like-balloon';
const TTL = 24 * 86400;
const isShow = ref(false);
const onHideMenu = () => {
  isShow.value = false;
  setToStorage({ key: KEY, value: true, expirationSeconds: TTL });
};

onMounted(async () => {
  await sleep(2500);
  isShow.value = !getFromStorage({ key: KEY }) && !props.liked;
});
</script>
